export function lowerCase(str) {
    return str.toLowerCase()
}

export function upperCase(str) {
    return str.toUpperCase()
}

export function capitalize(str) {
    if (!str) {
        return ''
    }
    return str
        .trim()
        .toLowerCase()
        .replace(/\w\S*/g, w => w.replace(/^\w/, c => c.toUpperCase()))
}

export function checkEmptyString(str) {
    if (!str) {
        return true
    }

    let tempStr = str.replace(/\s+/g, '')

    return !tempStr
}

export function innerHtml(data) {
    return {__html: data}
}

export function validEmail(email) {
    var re =
        // eslint-disable-next-line no-useless-escape
        /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
    return re.test(email)
}

export function validUsername(username) {
    var validcharacters =
        '1234567890-_.abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ'

    for (var i = 0, l = username.length; i < l; ++i) {
        if (validcharacters.indexOf(username.substr(i, 1)) === -1) {
            return false
        }
        return true
    }
}

export function numberWithCommas(n) {
    var parts = n.toString().split('.')
    return (
        parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',') +
        (parts[1] ? '.' + parts[1] : '')
    )
}

export function validatePhoneNumber(phone) {
    var re = /^\+\(?\d{1,4}\)?\s\d{3}\s\d{3}\s?\d{3,6}?$/
    return re.test(phone)
}

export function validateEmail(email) {
    const comprehensiveEmailRegex =
        /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/

    return comprehensiveEmailRegex.test(email)
}
